module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-wideAngle-larger-mobile.eb7c9e09.jpg";